import { createEvent, restore } from 'effector'
import { PassiveBalanceFilter } from './types'

export const setPassiveBalanceFilter = createEvent<PassiveBalanceFilter>()

export const $passiveBalanceFilter = restore(setPassiveBalanceFilter, {
  passiveBalanceCountries: [],
  product: '',
})
